export const loanProducts = [
  {
    productName: 'GAP',
    shortName: 'gap',
    fiName: 'gap',
    groupName: 'gapForm',
    rateName: 'gapRates',
    productTypeId: 2
  },
  {
    productName: 'PEP',
    shortName: 'pep',
    fiName: 'pep',
    groupName: 'pepForm',
    rateName: 'pepRates',
    productTypeId: 10
  },
  {
    productName: 'MMP',
    shortName: 'mmp',
    fiName: 'mmp',
    groupName: 'mmpForm',
    rateName: 'mmpRates',
    productTypeId: 3
  },
  {
    productName: 'Maintenance Benefit Agreement',
    shortName: 'ppm',
    fiName: 'ppm',
    groupName: 'ppmForm',
    rateName: 'ppmRates',
    productTypeId: 19
  },
  {
    productName: 'Key Protection',
    shortName: 'keyProtection',
    fiName: 'keyProtection',
    groupName: 'keyProtectionForm',
    rateName: 'keyProtectionRates',
    productTypeId: 18
  },
  {
    productName: 'Vehicle Return',
    shortName: 'vehicleReturn',
    fiName: 'vehicleReturn',
    groupName: 'vehicleReturnForm',
    rateName: 'vehicleReturnRates',
    productTypeId: 9
  },
  {
    productName: 'Screen Protection',
    shortName: 'sd',
    fiName: 'sd',
    groupName: 'sdForm',
    rateName: 'sdRates',
    productTypeId: 20
  },
  {
    productName: 'Payment Protection',
    shortName: 'paymentProtection',
    fiName: 'ppi',
    groupName: 'paymentProtectionForm',
    rateName: 'paymentProtectionRates',
    productTypeId: 4
  },
  {
    productName: 'CVP',
    shortName: 'cvp',
    fiName: 'cvp',
    groupName: 'cvpForm',
    rateName: 'cvpRates',
    productTypeId: 21
  }
];
